<!-- 宣告表 列表 sqm -->
<template>
  <h-list-page class="rohsDeclarationFormList_style">
    <h-card :title="h_i18n('5148fcc0412bafcd98e04d4d183d8e18')" width="100%" footer is-search @change-method="changeMethod">
      <h-area>
        <h-search :title="h_i18n('369d21daf7e505f05a3f16a8acf67ebc')">
          <h-input v-model="searchData.rohsNo" clearable @change="changeNull(searchData.rohsNo, 'rohsNo')">
          </h-input>
        </h-search>

        <h-search :title="h_i18n('341c769b32b164c53fa35e6d0c7ce809')">
          <h-input v-model="searchData.mtlName" clearable @change="changeNull(searchData.mtlName, 'mtlName')">
          </h-input>
        </h-search>

        <h-search :title="h_i18n('bf0de2a6d0dcc7ab42c1474ea076c6d5')">
          <h-input v-model="searchData.mtlNo" clearable @change="changeNull(searchData.mtlNo, 'mtlNo')">
          </h-input>
        </h-search>

        <h-search :title="h_i18n('5d73c09499a08557279f7554a0837404')">
          <h-select v-model="searchData.auditFactoryId" filterable clearable @change="changeNull(searchData.auditFactoryId, 'auditFactoryId') , clearFactoryId(searchData.auditFactoryId)">
            <h-option v-for="item in data.auditFactoryList" :key="item.departmentId" :label="item.departmentName" :value="item.departmentId"></h-option>
          </h-select>
        </h-search>

        <h-search :title="h_i18n('cec6876260f9cb712539bd8a42f54769')">
          <h-input v-model="searchData.testReportNumber" clearable @change="changeNull(searchData.testReportNumber, 'testReportNumber')" :placeholder="searchData.auditFactoryId ? h_i18n('02cc4f8f5a9aefbc03c778f7a5c989c7'):h_i18n('a0c9eb4c87d42f5d77aedf01db3a9be3')"
            :disabled="!searchData.auditFactoryId">
          </h-input>
        </h-search>

        <h-search :title="h_i18n('b86224e030e5948f96b70a4c3600b33f')">
          <h-select v-model="searchData.processNode" clearable filterable @change="changeNull(searchData.processNode, 'processNode')">
            <h-option :label="h_i18n('d804c61911aff62b3bd8705571f106c1')" value="12"></h-option>
            <!-- <h-option label="质量经理待发布" value="20"></h-option> -->
            <h-option :label="h_i18n('755aed833bf84ccc2fc2245c1bdfdd92')" value="25"></h-option>
            <h-option :label="h_i18n('397b239eeb88a8796b1f8bbf58de351e')" value="26"></h-option>
            <h-option :label="h_i18n('17e33ec9a1b14400f0e13a89adff6fd7')" value="30"></h-option>
            <h-option :label="h_i18n('1528b37e0e4ccb55ed708b9f1fbf1dbd')" value="32"></h-option>
            <h-option :label="h_i18n('8bda9bd1a1d13658f5c33f0bcab1f0dc')" value="31"></h-option>
            <h-option :label="h_i18n('494312483231c1e9a576b652d348cbe3')" value="40"></h-option>
          </h-select>
        </h-search>

        <h-search :title="h_i18n('f66233940b0acfaf83a1825cf714eb55')">
          <h-select v-model="searchData.effectStatus" clearable filterable @change="changeNull(searchData.effectStatus, 'effectStatus')">
            <h-option :label="h_i18n('996aab1c1d47062b88f794aef45b2b79')" value="0"></h-option>
            <h-option :label="h_i18n('c6cc397661432878e10a24834460da0d')" value="1"></h-option>
            <!-- <h-option label="作废" value="3"></h-option> -->
          </h-select>
        </h-search>

        <h-search :title="h_i18n('34fd3f101fa4ab483c50479c695fb58c')">
          <h-select v-model="searchData.rohsStatus" clearable filterable @change="changeNull(searchData.rohsStatus, 'rohsStatus')">
            <h-option :label="h_i18n('fd6e80f1e0199d6ecc3ee81ae04aa9ef')" value="0"></h-option>
            <h-option :label="h_i18n('c10f502eae7a1921c8be2cbdf21caec2')" value="1"></h-option>
            <h-option :label="h_i18n('72a2847f3b8ba821489b008459ba3e43')" value="2"></h-option>
          </h-select>
        </h-search>

        <h-search :title="h_i18n('809844de5f86e5f9da3e31e24d4e5808')">
          <h-date-picker @change="TimeChange(searchData.declarationDate, {start:'beginDateOne',end:'endDateOne'})" v-model="searchData.declarationDate"
            type="daterange" :start-placeholder="h_i18n('a3e3b88377c8a2f34e0f9ef6e67dbe62')" :end-placeholder="h_i18n('12f1d7ef38af6326c94fd11688f5b453')" :clearable="clearAble" />
        </h-search>

        <h-search :title="h_i18n('04a00a5426cc9527dd9e7a8815113158')">
          <h-date-picker @change="TimeChange(searchData.effectEndDate, {start:'beginDateTwo',end:'endDateTwo'})" v-model="searchData.effectEndDate"
            type="daterange" :start-placeholder="h_i18n('a3e3b88377c8a2f34e0f9ef6e67dbe62')" :end-placeholder="h_i18n('12f1d7ef38af6326c94fd11688f5b453')" :clearable="clearAble" />
        </h-search>

        <h-search :title="h_i18n('5a98b64b0d0c8c704b66d494ea784ab4')">
          <h-date-picker @change="TimeChange(searchData.checkTime, {start:'beginDateThird',end:'endDate1Third'})" v-model="searchData.checkTime"
            type="daterange" :start-placeholder="h_i18n('a3e3b88377c8a2f34e0f9ef6e67dbe62')" :end-placeholder="h_i18n('12f1d7ef38af6326c94fd11688f5b453')" :clearable="clearAble" />
        </h-search>

        <h-search :title="h_i18n('0039880117c13787732d259f5bc9f7f5')">
          <h-date-picker @change="TimeChange(searchData.saveTime, {start:'saveStartTime',end:'saveEndTime'})" v-model="searchData.saveTime"
            type="daterange" :start-placeholder="h_i18n('a3e3b88377c8a2f34e0f9ef6e67dbe62')" :end-placeholder="h_i18n('12f1d7ef38af6326c94fd11688f5b453')" :clearable="clearAble" />
        </h-search>
        <h-search :title="h_i18n('a001a226fdc34fd7121f9c4839c759a2')">
          <h-date-picker @change="TimeChange(searchData.updateTime, {start:'startUpdateTime',end:'endUpdateTime'})" v-model="searchData.updateTime"
            type="daterange" :start-placeholder="h_i18n('a3e3b88377c8a2f34e0f9ef6e67dbe62')" :end-placeholder="h_i18n('12f1d7ef38af6326c94fd11688f5b453')" :clearable="clearAble" />
        </h-search>

        <template #operate>
          <h-button type="primary" :loading="data.tableLoading" @click="getInfo(true)">
            <template #icon>
              <search />
            </template>{{ h_i18n('bee912d79eefb7335988c4997aa9138d') }}</h-button>
        </template>

      </h-area>
    </h-card>

    <h-table-card :title="h_i18n('3d2b8f26985da529d76b6d898ae3b6fe')" :is-left="0" :is-right="1" :h-data="data.dataOfTable">
      <template #buttonGroup>
        <h-button-group>
          <!-- <template v-for="item in data.btnListOfSqm" :key="item.code">
              <template v-if="item.code == 'mkhl_yhwzNew_xgb_insert1'">
                <h-button v-if="data.roleCode == 'S009'" type="primary" :loading="data.addBtnLoading" @click="addBtn">
                <add-four/>
                {{ item.name }}</h-button>
                  </template>
                <template v-if="item.code == 'mkhl_yhwzNew_xgb_export1'">
                <h-button type="primary" :loading="data.exportLoading" @click="excleBtn">
                  <export />
                  {{ item.name }}</h-button>
              </template>
          </template> -->
          <h-button v-if="data.roleCode == 'S009'" type="primary" :loading="data.addBtnLoading" @click="addBtn">
            <add-four/>{{ h_i18n('66ab5e9f24c8f46012a25c89919fb191') }}</h-button>
          <h-button type="primary" :loading="data.exportLoading" @click="excleBtn">
            <export />{{ h_i18n('55405ea6ff6fd823ffab7e6b10ddfa95') }}</h-button>
            <!-- <h-button type="primary" :loading="data.exportLoading" @click="backOldVersion">
            <history />
          切换旧版</h-button> -->
          <div class="dangerColor" style="display: flex;align-items: center;margin-left: 20px;font-size: 12px">{{ h_i18n('84a84c2d77921398d7f159f5c69ecba1') }}</div>
        </h-button-group>
      </template>

      <el-table :empty-text="h_i18n('8fd727180609a8164afad4b5eecc5544')" v-loading="data.tableLoading" @selection-change="handleSelectionChange" border 
        :data="data.dataOfTable" size="small" height="540" style="width: 100%;min-height:540px">
        <el-table-column type="index" :label="h_i18n('faaadc447b1c2b1adc920d9c9aedcc25')" width="40"></el-table-column>
        <el-table-column prop="rohsNo" :label="h_i18n('369d21daf7e505f05a3f16a8acf67ebc')" min-width="180"></el-table-column>
        <el-table-column prop="mtlName" :label="h_i18n('341c769b32b164c53fa35e6d0c7ce809')" min-width="200" class-name="textalignleft_style"></el-table-column>
        <el-table-column prop="mtlNo" :label="h_i18n('f1edca9f040d256cee01ef89fa5499f0')" min-width="130"></el-table-column>
        <el-table-column prop="relatedMtlNo" :label="h_i18n('ae6c2f49100d90869604ee4af29e7f0d')" min-width="130"></el-table-column>
        <el-table-column prop="declarationDate" :label="h_i18n('809844de5f86e5f9da3e31e24d4e5808')" min-width="120">
          <template #default="{ row }">
            <span>{{ time(row.declarationDate) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="effectEndDate" :label="h_i18n('04a00a5426cc9527dd9e7a8815113158')" min-width="120">
          <template #default="{ row }">
            <span>{{ time(row.effectEndDate) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="auditTwoName" :label="h_i18n('663829a6c56e9395f3ad246651e60387')" min-width="90"></el-table-column>
        <el-table-column prop="auditTwoDate" :label="h_i18n('8679e39997149952a7091d33e132b93c')" min-width="120">
          <template #default="{ row }">
            <span>{{ time(row.auditTwoDate) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="auditFactory" :label="h_i18n('5d73c09499a08557279f7554a0837404')" min-width="150"></el-table-column>
        <!-- <el-table-column prop="checkPerson" label="校核人" min-width="90"></el-table-column> -->
        <el-table-column prop="checkTime" :label="h_i18n('5a98b64b0d0c8c704b66d494ea784ab4')" min-width="120">
          <template #default="{ row }">
            <span>{{ time(row.checkTime) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="processNode" :label="h_i18n('3bf3c0a8d631d93aee55e4e47e2b2109')" min-width="120">
          <template #default="{ row }">
            <span v-if="row.processNode == '12'">{{ h_i18n('d804c61911aff62b3bd8705571f106c1') }}</span>
            <span v-if="row.processNode == '20'">{{ h_i18n('493ea518d1c8e18ea1de0340fdee83f2') }}</span>
            <span v-if="row.processNode == '25'">{{ h_i18n('755aed833bf84ccc2fc2245c1bdfdd92') }}</span>
            <span v-if="row.processNode == '26'">{{ h_i18n('397b239eeb88a8796b1f8bbf58de351e') }}</span>
            <span v-if="row.processNode == '30'">{{ h_i18n('17e33ec9a1b14400f0e13a89adff6fd7') }}</span>
            <span v-if="row.processNode == '32'">{{ h_i18n('1528b37e0e4ccb55ed708b9f1fbf1dbd') }}</span>
            <span v-if="row.processNode == '31'">{{ h_i18n('8bda9bd1a1d13658f5c33f0bcab1f0dc') }}</span>
            <span v-if="row.processNode == '40'">{{ h_i18n('494312483231c1e9a576b652d348cbe3') }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="effectStatus" :label="h_i18n('3fea7ca76cdece641436d7ab0d02ab1b')" min-width="100">
          <template #default="{ row }">
            <span v-if="row.effectStatus == '0'">{{ h_i18n('996aab1c1d47062b88f794aef45b2b79') }}</span>
            <span class="successColor" v-else-if="row.effectStatus == '1'">{{ h_i18n('c6cc397661432878e10a24834460da0d') }}</span>
            <!-- <span class="dangerColor" v-else-if="row.effectStatus == '3'">作废</span> -->
            <span v-else>{{ row.effectStatusName }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="rohsStatus" :label="h_i18n('34fd3f101fa4ab483c50479c695fb58c')" min-width="100">
          <template #default="{ row }">
            <span v-if="row.rohsStatus == '0'">{{ h_i18n('fd6e80f1e0199d6ecc3ee81ae04aa9ef') }}</span>
            <span v-if="row.rohsStatus == '1'">{{ h_i18n('c10f502eae7a1921c8be2cbdf21caec2') }}</span>
            <span v-if="row.rohsStatus == '2'">{{ h_i18n('72a2847f3b8ba821489b008459ba3e43') }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="supplyFor" :label="h_i18n('a1323cc265292654b418fd3ea7509701')" min-width="150"></el-table-column>
        <el-table-column prop="saveTime" :label="h_i18n('0039880117c13787732d259f5bc9f7f5')" min-width="170">
          <template #default="{ row }">
            <span>{{  time(row.saveTime,6) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="updateTime" :label="h_i18n('a001a226fdc34fd7121f9c4839c759a2')" min-width="170">
          <template #default="{ row }">
            <span>{{  time(row.updateTime,6) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="id" :label="h_i18n('ea5311cf294c025c2a0024aee7c2d976')" min-width="120"></el-table-column>
        <el-table-column prop="" :label="h_i18n('f630b9a4da10f81b7bb1c75bf6345558')" class-name="table_button_style">
          <template #default="{row}">
            <h-button type="warning" @click="openProcess(row)">{{ h_i18n('f630b9a4da10f81b7bb1c75bf6345558') }}</h-button>
          </template>
        </el-table-column>
        <el-table-column prop="" :label="h_i18n('2b6bc0f293f5ca01b006206c2535ccbc')" min-width="100" class-name="table_button_style">
          <template #default="{ row }">
            <h-button type="danger" v-if="(row.processNode == '12' || row.processNode == '32') && data.roleCode == 'S009'" @click="upDateBtn(row)">{{ h_i18n('8347a927c09a4ec2fe473b0a93f667d0') }}</h-button>
            <h-button type="danger" v-else-if="row.processNode == '26' && data.roleCode == 'S009'" @click="upDateBtn(row)">{{ h_i18n('8347a927c09a4ec2fe473b0a93f667d0') }}</h-button>
            <h-button type="warning" v-else-if="row.processNode == '25' && data.roleCode == 'S006'" @click="auditBtn(row)">{{ h_i18n('cf13b1a67881f454af469aa874f087e5') }}</h-button>
            <h-button type="primary" v-else @click="detailBtn(row)">{{ h_i18n('607e7a4f377fa66b0b28ce318aab841f') }}</h-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination background @size-change="handleSizeChange" @current-change="getInfo()"
        v-model:currentPage="searchData.pageNo" :page-size="10" layout="total, prev, pager, next,jumper"
        :total="data.total">
      </el-pagination> 
    </h-table-card>

    <h-dialog :title="h_i18n('ae762b31e735d05f32b0f8aef726da64')" class="process_dialog_style" :show="data.dialogOfProcess" width="70%" @close="data.dialogOfProcess = false, data.processData = []">
      <el-table :data="data.processData.slice((data.processPageNo-1)*10,data.processPageNo*10)"
          v-loading="data.processLoading" border size="small" height="540">
          <el-table-column prop="position" :label="h_i18n('8402fcdd8d97edd86fb1bc69059db687')" min-width="100"></el-table-column>
          <!-- <el-table-column prop="auditNickname" label="姓名" min-width="90"></el-table-column>
          <el-table-column prop="auditName" label="工号" min-width="90"></el-table-column> -->
          <el-table-column prop="auditDate" :label="h_i18n('19fcb9eb2594059036dfede5f4ec53e8')" min-width="170"></el-table-column>
          <el-table-column prop="auditStauts" :label="h_i18n('54bbba803f13eaab0f5441d97b13247a')" min-width="100">
            <template #default="{ row }">
              <span v-if="row.auditStatus == '1'" class="successColor">{{ h_i18n('23c1f39900b3af4c3263449782e288e1') }}</span>
              <span v-else-if="row.auditStatus == '2'" class="dangerColor">{{ h_i18n('32525478cd5c1c93de9c71246021b595') }}</span>
              <span v-else></span>
            </template>
          </el-table-column>
          <el-table-column prop="auditMark" :label="h_i18n('a6396f13c260444d561afaa9407467be')" min-width="200"></el-table-column>
        </el-table>
        <el-pagination background @current-change="processCurrentChange" v-model:currentPage="data.processPageNo"
                     :page-size="10" layout="total, prev, pager, next,jumper" :total="data.processPageTotal" :hide-on-single-page="data.processPageTotal <= 10">
      </el-pagination>
    </h-dialog>

  </h-list-page>
</template>



<script setup>
//Automatic script writing.
import h_i18n from '@/utils/Internationalization';

  import { reactive, getCurrentInstance, onMounted, onUpdated, nextTick, onBeforeMount, onActivated, onDeactivated } from "vue";
  import { useRoute } from "vue-router";
  import axios from "axios";
  import hButton from "../../../views/Templates/h-button.vue";
  const { proxy, ctx } = getCurrentInstance()
  const route = useRoute()
  const searchData = reactive({
    pageNo: 1,
    pageSize: 10,
  })
  const data = reactive({
    exportLoading:false,
    tableLoading:false,
    dataOfTable:[],
    keepalivestatus:0,
    auditFactoryList:[],
    btnCodeList:[
    "mkhl_yhwzNew_xgb_export1","mkhl_yhwzNew_xgb_insert1",
    ],
    btnListOfSqm:[],
    processLoading:false,
    dialogOfProcess:false,
    processPageNo:1,
    processPageTotal:0,
    processData:[],
  })
  // 切换旧版
const backOldVersion = () =>{
  if (process.env.NODE_ENV != 'production') {
    window.open(`http://sqm-test.qd-huangdao-test.haier.net/newproduct/rohs_haier_index1?resourceId=7&roleCode=${data.roleCode}&vCode=${data.supplyCode}&supplyCode=${data.supplyCode}&trueName=${data.trueName}&supplyName=${data.supplyName}&userName=${data.userName}&dataFrom=sqm`)
  }else{
    window.open(`https://sqm.haier.net/newproduct/rohs_haier_index1?resourceId=7&roleCode=${data.roleCode}&vCode=${data.supplyCode}&supplyCode=${data.supplyCode}&trueName=${data.trueName}&supplyName=${data.supplyName}&userName=${data.userName}&dataFrom=sqm`)
  }
}
// 按钮事件
const btnFunction = (btnCode) => {
  switch(btnCode){
  case "mkhl_yhwzNew_xgb_export1": // 导出
    break;

    case "mkhl_yhwzNew_xgb_insert1": // 新增
    break;
  }
}
// loading事件
const loadingFunction = (btnCode) => {
  switch(btnCode){
  case "mkhl_yhwzNew_xgb_export1":
    return

    case "mkhl_yhwzNew_xgb_insert1":
    return
  }
}
  /**
 * 传高度
 */
 const changeMethod = () => {
  proxy.postThisPageHeight();
};
/**
 * 勾选操作
 * @param {*} rowArr 选中行
 */
 const listCheckBoxChange = (rowArr) => {
  data.rowListOfCheck = rowArr
  // if(data.rowListOfCheck.length == 1){
  //   getTaskId()
  // }
};
// 清除按钮事件
const searchClear = (key) => {
  searchData[key] = undefined;
};
// input为空时undefined
const changeNull = (value, key) => {
  if (value === "") {
    searchData[key] = undefined;
  }
}
// 时间范围选择
const TimeChange = (date, {start,end}) => {
  if (date) {
    searchData[start] = proxy.time(date[0]);
    searchData[end] = proxy.time(date[1]);
  } else {
    searchData[start] = undefined;
    searchData[end] = undefined;
  }
}
// tabs切换
const tabsChange = () => {
  for (const key in searchData) {
    searchData[key] = null
  }
  searchData.pageNo = 1
  searchData.pageSize = 10
  
    getInfo(true)
  
  data.auditFactoryList = []
}

// 列表查询
const getInfo = (flag) => {
  if (true == flag) {
    searchData.pageNo = 1;
  }
  // console.log("getInfo")
  data.tableLoading = true;
  proxy.$http({
    // rohs_index1_middle_new
    url: "/base/newrohs/getRoHSPage", 
    method: "post",
    data: {
      ...searchData,
      mtlNo: searchData.mtlNo || undefined,
      // queryFlag:"sqm",
      name:undefined,
      nickName:undefined,
      declarationDate:undefined,
      effectEndDate:undefined,
      checkTime:undefined,
      saveTime:undefined,
      updateTime:undefined,
      supplyCode:data.supplyCode
    }
  }).then(res=>{
    data.dataOfTable = res.data.data.records
    data.total = res.data.data.total
  }).catch(err=>{
    data.dataOfTable = []
    data.total = 0
  }).finally(()=>{
    data.tableLoading = false
  })
}
// 历史数据查询 
const getHistoryInfo = (flag) => {
  if (true == flag) {
    searchData.pageNo = 1;
  }
  // console.log('getHistoryInfo')
  proxy.$http({
    //rohs_getOld_index1_middle 
    url: "/base/newrohs/getOldROHSPage", 
    method: "post",
    data: {
      ...searchData,
      mtlNo: searchData.mtlNo || undefined,
      queryFlag:"sqm",
      name:undefined,
      nickName:undefined,
      declarationDate:undefined,
      effectEndDate:undefined,
      checkTime:undefined,
      saveTime:undefined,
      updateTime:undefined,
      supplyCode:data.supplyCode
    }
  }).then(res=>{
    data.dataOfTable = res.data.records
    data.total = res.data.total
  }).catch(err=>{
    data.dataOfTable = []
    data.total = 0
  }).finally(()=>{
    data.tableLoading = false
  })
}

const auditFactoryRemoteMethod = (query) => {
  // if(query){
    proxy.$http({
      url:'/base/sysStructureTree/getSyb?sybName='+query,
      method:'get'
    }).then(res=>{
      data.auditFactoryList = res.data.data
    }).catch(err=>{

    }).finally(()=>{

    })
  // }
}
// 导出
const excleBtn = () => {
    if (data.total > 5000) {
      proxy.warning(
        { message: h_i18n('748c802d8fe36ada78520df791295747'), title: h_i18n('f148292ae0c683ca6fe4246350d309f6') },
        {
          confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),
          callback: (action) => { },
        }
      );
      return;
    }
    data.exportLoading = true;
    proxy.startLoading(h_i18n('607bb35de588d343f4e98298a7af2223'));
    proxy.httpFile(
      {
        method: "post",
        url: "/base/newrohs/exportRohsAll",
        data: {
          ...searchData,
          mtlNo: searchData.mtlNo ? searchData.mtlNo : undefined,
          declarationDate:undefined,
          effectEndDate:undefined,
          checkTime:undefined,
          saveTime:undefined,
          updateTime:undefined,
          pageSize: undefined,
          pageNo: undefined,
          // queryFlag:'sqm',
          supplyCode:data.supplyCode,
          supplyName:undefined,
          fixConfig:true,
        },
      },
      h_i18n('afdf574f2b4f505d06b039d8c6f142ff')
    ).then(res=>{
      data.exportLoading = false;
    }).catch(err=>{
      data.exportLoading = false;
      proxy.closeLoading()
    })
  
}
// 新增按钮
const addBtn = () => {
  proxy.$router.push({
    name: "rohsDeclarationFormAdd",
    query: {
      trueName:data.trueName,
      userName:data.userName,
      dataFrom:'sqm',
      kindType:'sqmAdd',
      supplyCode:data.supplyCode,
      supplyName:data.supplyName,
      userId:data.userId,
      isSupply : data.isSupply,
      roleCode: data.roleCode,
    }
  })
}
// 暂存的 修改
// 审核/校核驳回的 也修改
const upDateBtn = (row) => {
  let overruleType = 0
  if(row.processNode == '26' || row.processNode == '32'){
    // 质量部长驳回的重提
    overruleType = 1
  }else{
    overruleType = 0
  }
  proxy.$router.push({
    name: "rohsDeclarationFormModify",
    query: {
      trueName:data.trueName,
      userName:data.userName,
      dataFrom:'sqm',
      kindType:'sqmModify',
      supplyCode:data.supplyCode,
      supplyName:data.supplyName,
      rohsNo:row.rohsNo,
      roleCode: data.roleCode,
      id: row.id,
      overruleType:overruleType,
      isSupply : data.isSupply,
      userId:data.userId,
    }
  })
}
// 审核按钮
const auditBtn = (row) => {
  proxy.$router.push({
    name: "rohsDeclarationFormAudit",
    query: {
      trueName:data.trueName,
      userName:data.userName,
      dataFrom:'sqm',
      kindType:'sqmAudit',
      supplyCode:data.supplyCode,
      supplyName:data.supplyName,
      rohsNo:row.rohsNo,
      roleCode: data.roleCode,
      id: row.id
    }
  })
}

// 详情
const detailBtn = (row) => {
  proxy.$router.push({
    name: "rohsDeclarationFormDetail",
    query: {
      trueName:data.trueName,
      userName:data.userName,
      dataFrom:'sqm',
      kindType:'sqmDetail',
      supplyCode:data.supplyCode,
      supplyName:data.supplyName,
      rohsNo:row.rohsNo,
      id: row.id
    }
  })
}
/**
 * 打开流程 图表
 */
 const openProcess = (row) => {
  data.processLoading = true
  proxy.$http({
    url:'/base/newrohs/findCheckInfoByRohsId',
    method:'post',
    data:{
      rohsId: row.id,
      pageNo: 1,
      pageSize: 1000
    }
  }).then(res=>{
    if(res.data.code == '0'){
      data.processData = res.data.data.records
      data.processPageTotal = res.data.data.total
      data.dialogOfProcess = true
    }else{
      data.processData = []
      data.processPageTotal = 0
    }
  }).catch(err=>{
    data.processData = []
    data.processPageTotal = 0
  }).finally(()=>{
    data.processLoading = false
  })
}
// dialog table 翻页
const processCurrentChange = (v) => {
  data.processPageNo = v
}
// 清除工厂
const clearFactoryId = (v) => {
  if(!v){
    searchData.testReportNumber = undefined
  }
}
onMounted(() => {
  if(route.query.dataFrom != 'sqm'){
    proxy.$router.replace('/404')
    return
  }
    if(!route.query.supplyCode){
      proxy.info({title: h_i18n('02d9819ddaaaeb1b7b22b12608c7e5ca'), message: h_i18n('c0f92e28b64a4268408f10aa60dc47c8'),confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),
        callback: (action) => { 
          proxy.$router.back()        
        },})
      return
    }
    if (route.query) {
      data.supplyCode = route.query.supplyCode;
      searchData.supplyCode = route.query.supplyCode;
      data.supplyName = route.query.supplyName;
      data.trueName = route.query.trueName || route.query.nickName;
      data.roleCode = route.query.roleCode;
      data.userName = route.query.userName || route.query.nickName;
      data.userId = route.query.userId
      data.isSupply = route.query.isSupply
    }
    if(route.query.parentId && route.query.parentId != 'null' && route.query.parentId != 'undefined' && route.query.parentId != ''){
      // let p = proxy.getButtonFromSqm(route.query.parentId,route.query.roleCode)
      // p.then(res=>{
      //   if(res.length > 0){
      //     data.btnListOfSqm = res
      //   }
      // })
    }
    getInfo()
    auditFactoryRemoteMethod('')
  })
onActivated(() => {
  if (data.keepalivestatus == 0) {
    // console.log("首次打开");
    data.keepalivestatus ++
  } else {
    // console.log("操作完之后打开");
    getInfo()
    proxy.postThisPageHeight();
  }
})
onDeactivated(() => {
  // console.log("keepalive-deactivated页面关闭时触发");
})

</script>

<style lang="scss">
.rohsDeclarationFormList_style{
  .el-table td.textalignleft_style .cell {
    text-align: left !important;
  }
.table_button_style{
  padding: 7px 0 !important;
}
}
.tabs_style {
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  background-color: transparent;
  .el-tabs__header {
    border-radius: 8px;
    border-bottom: 0px;
  }
  .el-tabs__content {
    padding: 0px;
  }
  #tab-now {
    border-top-left-radius: 15px;
  }
  .el-tabs__item.is-active {
    border-right: 0px;
    border-left: 0px;
  }
}
.process_dialog_style{
  .haier-dialog{
    top:100px;

  }
}
.table_button_style{
  padding: 7px 0 !important;
}
</style>